<template>
  <TransitionGroup name="overlay-layer" tag="div" class="overlay-layer" aria-live="polite">
    <BaseOverlay
      v-for="overlay in activeOverlays"
      :key="overlay.config.uid"
      :config="overlay.config"
      @dismiss="$emit('dismiss', overlay.config.uid)"
      @submit="(data: unknown) => $emit('submit', overlay.config.uid, data)"
    />
  </TransitionGroup>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { ActiveOverlay } from '../../composables/useOverlays'
import BaseOverlay from './BaseOverlay.vue'

defineProps({
  activeOverlays: {
    type: Array as PropType<ActiveOverlay[]>,
    default: () => [],
  },
})

defineEmits<{
  dismiss: [uid: string]
  submit: [uid: string, data: unknown]
}>()
</script>

<style scoped lang="scss">
.overlay-layer {
  position: absolute;
  inset: 0;
  z-index: 70;
  pointer-events: none;
}

.overlay-layer-enter-active,
.overlay-layer-leave-active {
  transition: opacity 300ms ease;
}

.overlay-layer-enter-from,
.overlay-layer-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .overlay-layer-enter-active,
  .overlay-layer-leave-active {
    transition-duration: 1ms;
  }
}
</style>
